// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TimePicker_container__XXxOc {
    display: inline-block;
    width: 100%;
}

.TimePicker_container__XXxOc ul:first-of-type {
    width: 100%;
    background-color: var(--color-text-light) !important;
}

.TimePicker_twelveHourContainer__HErZ1 {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.TimePicker_timeContainer__uETCV {
    width: 100%;
    font-size: 14px;
}
`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/TimePicker/TimePicker.module.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,oDAAoD;AACxD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,eAAe;AACnB","sourcesContent":[".container {\n    display: inline-block;\n    width: 100%;\n}\n\n.container ul:first-of-type {\n    width: 100%;\n    background-color: var(--color-text-light) !important;\n}\n\n.twelveHourContainer {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n}\n\n.timeContainer {\n    width: 100%;\n    font-size: 14px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `TimePicker_container__XXxOc`,
	"twelveHourContainer": `TimePicker_twelveHourContainer__HErZ1`,
	"timeContainer": `TimePicker_timeContainer__uETCV`
};
export default ___CSS_LOADER_EXPORT___;
